import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/PetaniRT.css";

const PetaniFP = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [tanggal, setTanggal] = useState("");

  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [finalPanens, setFinalPanens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* =========================================================
     LOAD DATA
  ========================================================= */

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    // Ambil informasi user
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;

        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    fetchFinalPanens();
  }, []);

  /* =========================================================
     FETCH FINAL PANEN
  ========================================================= */

  const fetchFinalPanens = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/view_final_panen",
        {
          withCredentials: true,
        }
      );

      setFinalPanens(response.data.final_panens || []);
    } catch (err) {
      console.error("Error fetching final panen:", err);
      setError("Terjadi kesalahan saat memuat data.");
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     LOGOUT
  ========================================================= */

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        {
          withCredentials: true,
        }
      );

      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);

      Swal.fire(
        "Gagal",
        "Gagal logout. Silakan coba lagi.",
        "error"
      );
    }
  };

  /* =========================================================
     TAMBAH FINAL PANEN
  ========================================================= */

  const handleTambah = () => {
    Swal.fire({
      title: "Tambah Final Panen",
      html: `
        <div class="swal-form text-start mt-2">

          <div class="mb-3">
            <label class="fw-semibold text-muted small mb-1">
              ID Rencana Panen
            </label>

            <input
              id="rencana_panen_id"
              type="number"
              class="form-control rounded-3"
              placeholder="Contoh: 15"
            />
          </div>

          <div class="mb-2">
            <label class="fw-semibold text-muted small mb-1">
              Berat Sawit Awal (Kg)
            </label>

            <input
              id="berat_sawit"
              type="number"
              class="form-control rounded-3"
              placeholder="Contoh: 1500"
            />
          </div>

        </div>
      `,

      showCancelButton: true,

      confirmButtonText: "Simpan Data",
      cancelButtonText: "Batal",

      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",

      customClass: {
        confirmButton: "rounded-pill px-4 fw-bold",
        cancelButton: "rounded-pill px-4 fw-medium",
      },

      preConfirm: () => {
        const rencana_panen_id =
          document.getElementById("rencana_panen_id").value;

        const berat_sawit =
          document.getElementById("berat_sawit").value;

        if (!rencana_panen_id || !berat_sawit) {
          Swal.showValidationMessage(
            "Semua field wajib diisi"
          );

          return false;
        }

        return {
          rencana_panen_id,
          berat_sawit,
        };
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            "https://c-greenproject.org:7500/create_final_panen",
            result.value,
            {
              withCredentials: true,
            }
          );

          Swal.fire(
            "Berhasil",
            response.data.message,
            "success"
          );

          fetchFinalPanens();
        } catch (err) {
          Swal.fire(
            "Gagal",
            err.response?.data?.error ||
              "Terjadi kesalahan saat menyimpan data.",
            "error"
          );
        }
      }
    });
  };

  /* =========================================================
     FORMAT STATUS
  ========================================================= */

  const getStatusBadge = (status) => {
    const s = String(status || "Tertunda")
      .toLowerCase()
      .trim();

    if (
      s.includes("terkirim") ||
      s.includes("selesai") ||
      s.includes("diterima")
    ) {
      return (
        <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill border border-success-subtle fw-semibold">
          Selesai
        </span>
      );
    }

    if (
      s.includes("jalan") ||
      s.includes("proses") ||
      s.includes("pengiriman")
    ) {
      return (
        <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill border border-primary-subtle fw-semibold">
          Proses Pengiriman
        </span>
      );
    }

    if (
      s.includes("batal") ||
      s.includes("gagal") ||
      s.includes("tolak")
    ) {
      return (
        <span className="badge bg-danger-subtle text-danger px-3 py-2 rounded-pill border border-danger-subtle fw-semibold">
          Gagal
        </span>
      );
    }

    return (
      <span className="badge bg-warning-subtle text-warning-emphasis px-3 py-2 rounded-pill border border-warning-subtle fw-semibold text-capitalize">
        {status || "Tertunda"}
      </span>
    );
  };

  /* =========================================================
     FORMAT ANGKA
  ========================================================= */

  const formatNumber = (num) => {
    if (
      num === null ||
      num === undefined ||
      num === "" ||
      isNaN(Number(num))
    ) {
      return "-";
    }

    return Number(num).toLocaleString("id-ID");
  };

  const formatRupiah = (num) => {
    if (
      num === null ||
      num === undefined ||
      num === "" ||
      isNaN(Number(num))
    ) {
      return "-";
    }

    return `Rp ${Number(num).toLocaleString("id-ID")}`;
  };

  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <div className="d-flex flex-column bg-light min-vh-100">

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="header bg-white shadow-sm border-bottom">

        <img
          src="/static/logo_potrait.png"
          alt="Logo"
        />

        <div className="top-right">

          <span
            className="fw-medium text-secondary"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/profile")}
          >
            {userInfo.full_name} |
          </span>

          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>

        </div>
      </div>


      {/* =====================================================
          BODY
      ===================================================== */}

      <div className="d-flex flex-grow-1">

        {/* ===================================================
            SIDEBAR
        =================================================== */}

        <div
          className="sidebar p-3 bg-white shadow-sm"
          id="sidebar"
        >

          <p
            id="sidebar-title"
            className="text-muted small mb-1"
          >
            Portal Sistem Traceability
          </p>

          <h6
            id="sidebar-subtitle"
            className="fw-bold text-success mb-3"
          >
            Telsa Super Apps
          </h6>

          <p
            id="sidebar-date"
            className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2"
          >
            <img
              src="/static/schedule_11145854.png"
              alt="Date"
              style={{ width: "16px" }}
            />

            {tanggal}
          </p>


          {/* SIDEBAR MENU */}

          <div
            className="list-group list-group-flush mt-3"
            id="sidebar-menu"
          >

            {/* Beranda */}

            <div
              onClick={() => navigate("/petani")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petani"
                  ? "bg-success text-white"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/eco-home_7633847.png"
                alt="Home"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petani"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />

              Beranda
            </div>


            {/* Rencana Tanam */}

            <div
              onClick={() => navigate("/petanirt")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirt"
                  ? "bg-success text-white"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/Tanam.png"
                alt="Planting"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petanirt"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />

              Rencana Tanam
            </div>


            {/* Rencana Panen */}

            <div
              onClick={() => navigate("/petanirp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirp"
                  ? "bg-success text-white"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/panen.png"
                alt="Harvest"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petanirp"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />

              Rencana Panen
            </div>


            {/* Final Panen */}

            <div
              onClick={() => navigate("/petanifp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanifp"
                  ? "bg-success text-white"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/FinalPanen.png"
                alt="Final Panen"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petanifp"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />

              Final Panen
            </div>


            {/* Penjualan */}

            <div
              onClick={() => navigate("/petanip")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanip"
                  ? "bg-success text-white"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/sell_8087698.png"
                alt="Sales"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/petanip"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />

              Penjualan
            </div>

          </div>
        </div>


        {/* ===================================================
            MAIN CONTENT
        =================================================== */}

        <div
          className="main-content flex-grow-1 p-4"
          style={{
            minWidth: 0,
            width: "100%",
          }}
        >

          {/* PAGE HEADER */}

          <div className="d-flex justify-content-between align-items-center mb-4">

            <h2 className="fw-bold text-dark mb-0">
              Manajemen Final Panen
            </h2>

            <button
              className="btn btn-success rounded-pill px-4 shadow-sm fw-medium"
              onClick={handleTambah}
            >
              <i className="fa fa-plus me-2"></i>
              Tambah Final Panen
            </button>

          </div>


          <div className="divider mb-4"></div>


          {/* =================================================
              TABLE CARD
          ================================================= */}

          <div
            className="content-box border-0 shadow-sm rounded-4 bg-white"
            style={{
              width: "100%",
              overflow: "hidden",
            }}
          >

            {/* TABLE HEADER */}

            <div
              className="d-flex justify-content-between align-items-center p-4"
              style={{
                borderBottom: "1px solid #edf0ed",
              }}
            >

              <div>
                <h4 className="fw-bold text-success mb-1">
                  Daftar Final Panen
                </h4>

                <small className="text-muted">
                  Data hasil panen yang telah dicatat
                </small>
              </div>

              <span className="badge bg-success-subtle text-success rounded-pill px-3 py-2">
                {finalPanens.length} Data
              </span>

            </div>


            {/* =================================================
                LOADING
            ================================================= */}

            {loading ? (

              <div className="text-center py-5">

                <div
                  className="spinner-border text-success"
                  role="status"
                >
                  <span className="visually-hidden">
                    Loading...
                  </span>
                </div>

                <p className="text-muted mt-2 mb-0">
                  Memuat data final panen...
                </p>

              </div>


            ) : error ? (

              /* =================================================
                 ERROR
              ================================================= */

              <div className="p-4">

                <div className="alert alert-danger rounded-3 py-3 px-4 mb-0">
                  {error}
                </div>

              </div>


            ) : finalPanens && finalPanens.length > 0 ? (

              /* =================================================
                 TABLE
              ================================================= */

              <div
                className="final-panen-table-wrapper"
                style={{
                  width: "100%",
                  overflowX: "auto",
                  overflowY: "visible",
                  WebkitOverflowScrolling: "touch",
                }}
              >

                <table
                  className="table align-middle mb-0 final-panen-table"
                  style={{
                    minWidth: "1750px",
                    width: "100%",
                    tableLayout: "fixed",
                  }}
                >

                  <thead>

                    <tr>

                      <th
                        style={{
                          width: "70px",
                          textAlign: "center",
                        }}
                      >
                        ID
                      </th>

                      <th
                        style={{
                          width: "160px",
                        }}
                      >
                        Nama Petani
                      </th>

                      <th
                        style={{
                          width: "130px",
                          textAlign: "center",
                        }}
                      >
                        Jenis Sawit
                      </th>

                      <th
                        style={{
                          width: "190px",
                        }}
                      >
                        Lokasi Lahan
                      </th>

                      <th
                        style={{
                          width: "210px",
                        }}
                      >
                        Pabrik Tujuan
                      </th>

                      <th
                        style={{
                          width: "180px",
                        }}
                      >
                        Logistik
                      </th>

                      <th
                        style={{
                          width: "130px",
                          textAlign: "center",
                        }}
                      >
                        Berat Awal
                      </th>

                      <th
                        style={{
                          width: "130px",
                          textAlign: "center",
                        }}
                      >
                        Berat Akhir
                      </th>

                      <th
                        style={{
                          width: "120px",
                          textAlign: "center",
                        }}
                      >
                        Usia
                        <br />
                        (Tahun)
                      </th>

                      <th
                        style={{
                          width: "150px",
                          textAlign: "right",
                        }}
                      >
                        Harga/Kg
                      </th>

                      <th
                        style={{
                          width: "170px",
                          textAlign: "right",
                        }}
                      >
                        Total Harga
                      </th>

                      <th
                        style={{
                          width: "160px",
                          textAlign: "center",
                        }}
                      >
                        Status
                      </th>

                      <th
                        style={{
                          width: "130px",
                          textAlign: "center",
                        }}
                      >
                        Tgl Kirim
                      </th>

                      <th
                        style={{
                          width: "130px",
                          textAlign: "center",
                        }}
                      >
                        Tgl Terima
                      </th>

                      <th
                        style={{
                          width: "180px",
                          textAlign: "center",
                        }}
                      >
                        Tracking ID
                      </th>

                    </tr>

                  </thead>


                  <tbody>

                    {finalPanens.map((panen, index) => (

                      <tr
                        key={`fp-${panen.id || index}`}
                      >

                        {/* ID */}

                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <span className="fw-bold text-secondary font-monospace">
                            #{panen.id}
                          </span>
                        </td>


                        {/* NAMA PETANI */}

                        <td>
                          <div
                            style={{
                              whiteSpace: "normal",
                              overflowWrap: "break-word",
                              fontWeight: 600,
                              color: "#212529",
                            }}
                          >
                            {panen.nama || "-"}
                          </div>
                        </td>


                        {/* JENIS SAWIT */}

                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <span
                            className="badge bg-success-subtle text-success border border-success-subtle rounded-pill px-3 py-2"
                          >
                            {panen.jenis_sawit || "-"}
                          </span>
                        </td>


                        {/* LOKASI */}

                        <td>

                          <div
                            title={panen.lokasi_lahan || "-"}
                            style={{
                              whiteSpace: "normal",
                              overflowWrap: "break-word",
                              lineHeight: "1.5",
                            }}
                          >
                            {panen.lokasi_lahan || "-"}
                          </div>

                        </td>


                        {/* PABRIK */}

                        <td>

                          <div
                            title={panen.pabrik_tujuan || "-"}
                            style={{
                              whiteSpace: "normal",
                              overflowWrap: "break-word",
                              wordBreak: "normal",
                              lineHeight: "1.5",
                              fontWeight: 600,
                              color: "#343a40",
                            }}
                          >
                            {panen.pabrik_tujuan || "-"}
                          </div>

                        </td>


                        {/* LOGISTIK */}

                        <td>

                          <div
                            title={panen.logistik || "-"}
                            style={{
                              whiteSpace: "normal",
                              overflowWrap: "break-word",
                              wordBreak: "normal",
                              lineHeight: "1.5",
                              color: "#6c757d",
                            }}
                          >
                            {panen.logistik || "-"}
                          </div>

                        </td>


                        {/* BERAT AWAL */}

                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <span className="font-monospace text-muted">
                            {formatNumber(panen.berat_awal)}
                          </span>

                          <small className="text-muted ms-1">
                            kg
                          </small>
                        </td>


                        {/* BERAT AKHIR */}

                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >

                          {panen.berat_akhir ? (

                            <>
                              <span className="font-monospace fw-bold text-dark">
                                {formatNumber(panen.berat_akhir)}
                              </span>

                              <small className="text-muted ms-1">
                                kg
                              </small>
                            </>

                          ) : (

                            <span className="text-muted">
                              - kg
                            </span>

                          )}

                        </td>


                        {/* USIA */}

                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >

                          {typeof panen.usia === "number" &&
                          !isNaN(panen.usia) ? (

                            <span className="fw-medium">
                              {panen.usia.toFixed(1)}
                            </span>

                          ) : (

                            <span className="text-muted">
                              -
                            </span>

                          )}

                        </td>


                        {/* HARGA */}

                        <td
                          style={{
                            textAlign: "right",
                          }}
                        >

                          <span className="font-monospace text-success fw-medium">
                            {formatRupiah(
                              panen.harga_per_kg
                            )}
                          </span>

                        </td>


                        {/* TOTAL HARGA */}

                        <td
                          style={{
                            textAlign: "right",
                          }}
                        >

                          <span className="font-monospace text-success fw-bold">
                            {formatRupiah(
                              panen.total_harga
                            )}
                          </span>

                        </td>


                        {/* STATUS */}

                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >
                          {getStatusBadge(
                            panen.pengiriman?.status
                          )}
                        </td>


                        {/* TANGGAL KIRIM */}

                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >

                          <span className="small text-muted">
                            {panen.pengiriman
                              ?.tanggal_dikirim || "-"}
                          </span>

                        </td>


                        {/* TANGGAL TERIMA */}

                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >

                          <span className="small text-muted">
                            {panen.pengiriman
                              ?.tanggal_diterima || "-"}
                          </span>

                        </td>


                        {/* TRACKING ID */}

                        <td
                          style={{
                            textAlign: "center",
                          }}
                        >

                          {panen.pengiriman?.tracking_id ? (

                            <span
                              className="badge bg-light text-dark border font-monospace"
                              style={{
                                maxWidth: "160px",
                                display: "inline-block",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                              }}
                            >
                              {panen.pengiriman.tracking_id}
                            </span>

                          ) : (

                            <span className="text-muted">
                              -
                            </span>

                          )}

                        </td>

                      </tr>

                    ))}

                  </tbody>

                </table>

              </div>


            ) : (

              /* =================================================
                 EMPTY DATA
              ================================================= */

              <div className="text-center py-5 text-muted bg-light rounded-3 m-4">

                <i
                  className="fa fa-clipboard-check mb-3 opacity-50"
                  style={{
                    fontSize: "3rem",
                  }}
                ></i>

                <h5 className="fw-semibold">
                  Belum Ada Final Panen
                </h5>

                <p className="mb-0">
                  Silakan tambahkan data final panen baru Anda.
                </p>

              </div>

            )}

          </div>

        </div>

      </div>


      {/* =====================================================
          TABLE STYLE
      ===================================================== */}

      <style>{`

        .final-panen-table {
          border-collapse: separate !important;
          border-spacing: 0;
        }

        .final-panen-table thead th {
          background: #f5f8f6 !important;
          color: #344054;
          font-size: 14px;
          font-weight: 700;
          padding: 16px 14px !important;
          border-top: 1px solid #e3e8e5;
          border-bottom: 1px solid #dfe5e1;
          white-space: nowrap;
          vertical-align: middle;
        }

        .final-panen-table tbody td {
          padding: 17px 14px !important;
          border-bottom: 1px solid #edf0ee;
          vertical-align: middle;
          color: #344054;
          background: #ffffff;
        }

        .final-panen-table tbody tr {
          transition: background-color 0.15s ease;
        }

        .final-panen-table tbody tr:hover td {
          background-color: #f8fcf9;
        }

        .final-panen-table tbody tr:last-child td {
          border-bottom: none;
        }

        .final-panen-table-wrapper {
          scrollbar-width: thin;
          scrollbar-color: #b8c8bd #f1f4f2;
        }

        .final-panen-table-wrapper::-webkit-scrollbar {
          height: 9px;
        }

        .final-panen-table-wrapper::-webkit-scrollbar-track {
          background: #f1f4f2;
        }

        .final-panen-table-wrapper::-webkit-scrollbar-thumb {
          background: #b8c8bd;
          border-radius: 10px;
        }

        .final-panen-table-wrapper::-webkit-scrollbar-thumb:hover {
          background: #198754;
        }

        @media (max-width: 992px) {

          .main-content {
            padding: 20px !important;
          }

          .final-panen-table {
            min-width: 1750px !important;
          }

        }

        @media (max-width: 768px) {

          .main-content {
            padding: 15px !important;
          }

          .content-box {
            border-radius: 12px !important;
          }

          .final-panen-table {
            min-width: 1750px !important;
          }

        }

      `}</style>

    </div>
  );
};

export default PetaniFP;